export interface InstitutionDetailsData {
  institutionName: string;
  townName: string;
  isEnrollmentGroupForCurrentPedagogicalYear: boolean;
}

export const institutionDetailsInitialData: InstitutionDetailsData  = {
  institutionName: "",
  townName: "",
  isEnrollmentGroupForCurrentPedagogicalYear: false,
};

